/**
 * The browser's keyboard shortcuts, read the same from a key press in a page (the Desktop's
 * `before-input-event`) and in the tab's own controls (the renderer's `keydown`).
 */
export type BrowserShortcut =
  | 'focus-address'
  | 'reload'
  | 'hard-reload'
  | 'back'
  | 'forward'
  | 'new-tab'
  | 'close-tab'
  | 'find'
  | 'zoom-in'
  | 'zoom-out'
  | 'zoom-reset';

/** A key press: Electron's `Input`, or a `KeyboardEvent`'s keys and modifiers. */
export type BrowserKeyInput = {
  key: string;
  meta: boolean;
  control: boolean;
  shift: boolean;
  alt: boolean;
};

const COMMANDS: Readonly<Record<string, BrowserShortcut>> = {
  l: 'focus-address',
  r: 'reload',
  '[': 'back',
  ']': 'forward',
  t: 'new-tab',
  w: 'close-tab',
  f: 'find',
  '=': 'zoom-in',
  '+': 'zoom-in',
  '-': 'zoom-out',
  '0': 'zoom-reset',
};

/**
 * The browser shortcut a key press is, as in Chrome (⌘ on macOS, Ctrl elsewhere), or `null` when
 * the page keeps it.
 */
export function browserShortcut(input: BrowserKeyInput, mac: boolean): BrowserShortcut | null {
  if (input.key === 'F5' && !input.meta && !input.control && !input.alt)
    return input.shift ? 'hard-reload' : 'reload';
  const command = mac ? input.meta && !input.control : input.control;
  if (!command || input.alt) return null;
  const key = input.key.toLowerCase();
  // ⇧⌘R is Chrome's hard reload; shift otherwise only reaches `+` (⌘⇧= on most layouts).
  if (input.shift) return key === 'r' ? 'hard-reload' : key === '+' ? 'zoom-in' : null;
  return COMMANDS[key] ?? null;
}
